export default "__VITE_ASSET__iRXxHKSp__"